module.exports = __webpack_public_path__ + "static/img/img02.d26085b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img02.png
// module id = ujGI
// module chunks = 1